import Enumerable from "linq";
import { DomainRegistry } from "../../../../../domain";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference, QuoteBehaviorKinds } from "../../../../../domain/format";
import { IFormatTreeSourceFilterable } from "./IFormatTreeSourceFilterable";

export class QuotableFormatFilter implements IFormatTreeSourceFilterable {
  constructor(private _quoteSourceDocumentId: number) {
  }
  
  public async filter(directories: Directory<string, FormatReference>[]): Promise<Directory<string, FormatReference>[]> {
    if (!this._quoteSourceDocumentId || !isFinite(this._quoteSourceDocumentId) || !directories) { return directories; }
    const repository = DomainRegistry.document.getDocumentRepository();
    // 指定が無い場合は長さ0の配列、指定がある場合は文書のFormatOriginalIdも追加済み
    const quotableFormatIds = await repository.getQuotableDestinationFormatIds(this._quoteSourceDocumentId);
    return directories
      .map(d => this.filterDirectory(d, quotableFormatIds))
      .map(d => this.filterDirectoryByQuoteBehavior(d));
  }

  private filterDirectory(directory: Directory<string, FormatReference>, availableFormatIds: number[]): Directory<string, FormatReference> {
    if (!availableFormatIds || availableFormatIds.length === 0) { return directory; }
    const cloned = directory.clone();
    cloned.entities = Enumerable.from(directory.entities).where(e => this.isAvailableFormat(e, availableFormatIds)).toArray();
    cloned.nodes = Enumerable.from(directory.nodes).select(n => this.filterDirectory(n, availableFormatIds)).toArray();
    return cloned;
  }

  private isAvailableFormat(format: FormatReference, availableFormatIds: number[]): boolean {
    return availableFormatIds.some(id => format.id === id);
  }

  /**
   * 本来はここでフィルターするだけでは足りていないが、相澤病院ではここでフィルターするので不足しない見込み
   */
  private filterDirectoryByQuoteBehavior(directory: Directory<string, FormatReference>): Directory<string, FormatReference> {
    const cloned = directory.clone();
    cloned.entities = Enumerable.from(directory.entities).where(e => e.quoteBehaviorKind !== QuoteBehaviorKinds.Disabled).toArray();
    cloned.nodes = Enumerable.from(directory.nodes).select(n => this.filterDirectoryByQuoteBehavior(n)).toArray();
    return cloned;
  }
}
